import { AddNewButtonShell } from '@/components/RootScreenButtons/buildingBlocks/AddNewButtonShell';
import { useAppPush } from '@/hooks/useAppPush';
import useTranslation from '@/hooks/useTranslation';

export const GoToArchiveButton = () => {
  const t = useTranslation();
  const { push } = useAppPush();
  return (
    <AddNewButtonShell
      onClick={() => {
        push('/archive');
      }}
      hideAddIcon
    >
      {t('section.ARCHIVE')}
    </AddNewButtonShell>
  );
};
